import { Grid, TextField, TextFieldProps, styled } from "@material-ui/core";
import { lang } from "i18nLang";
import PropTypes from "prop-types";
import { useState } from "react";
import ColumnField from "./ColumnField";

const GridPadding = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 2),
}));

interface IProps {
  /** Propriedade name para identificar o component*/
  name: string;
  /** Valor inicial para key deste campo */
  defaultKey: string;
  /** Valor inicial para este campo */
  defaultValue: string;
  /** Propriedade onChange irá chamar uma função para alteração do component */
  onChange: Function;
  /** Propriedades extras do campo ColumnField */
  inputProps?: TextFieldProps;
}

/** O component trabalha de forma a ser validado pelo seu primeiro campo onde será atribuido seu nome,
 * logo após, ser informado o campo é habilitado o proximo campo para se informar a coluna referente ao nome.
 * @category Components */
const CustomColumnControl = ({
  name,
  onChange,
  inputProps,
  defaultKey,
  defaultValue,
}: IProps) => {
  const [key, setKey] = useState(defaultKey || "");
  const [value, setValue] = useState(defaultValue || "");

  const handleChangeKey = (ev) => {
    const newKey = ev.target.value;

    if (newKey) {
      onChange(name, newKey, value);
    }
    setKey(newKey);
  };

  const handleChangeValue = (name, inputValue) => {
    inputValue = inputValue.toUpperCase();
    if (key) {
      onChange(name, key, inputValue);
    }
    setValue(inputValue);
  };

  return (
    <Grid container item xs alignItems="flex-start">
      <GridPadding container item xs={6} md={6} alignItems="center">
        <TextField
          fullWidth
          size="small"
          label={lang("name")}
          name={name + "-label"}
          value={key}
          onChange={handleChangeKey}
          onKeyDown={(ev) => ev.stopPropagation()}
        />
      </GridPadding>
      <GridPadding container item xs={6} md={6} alignItems="center">
        <ColumnField
          name={name}
          disabled={key === ""}
          value={value}
          onChange={handleChangeValue}
          inputProps={inputProps}
        />
      </GridPadding>
    </Grid>
  );
};

CustomColumnControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  inputProps: PropTypes.object,
};

export default CustomColumnControl;
